import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforschooltripinpune() {



  const cardData =
  {
    keyword: 'Bus Hire for School Trips in Pune',
    heading: 'Amruta Travels: Bus Hire for School Trips in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers safe and reliable Bus Hire for School Trips in Pune, providing the perfect transportation solution for educational tours, picnics, and excursions. Our fleet of well-maintained AC and Non-AC buses is equipped with comfortable push-back seats, ample space, and safety features to ensure a pleasant and secure journey for students and staff. Each bus is driven by experienced, background-verified chauffeurs who follow all safety and traffic regulations. Whether it’s a short local trip or an outstation educational tour to destinations like Lonavala, Mahabaleshwar, or Shirdi, Amruta Travels’ School Trip Bus Rental in Pune guarantees punctual, smooth, and comfortable travel. With our commitment to safety, cleanliness, and reliability, we make every school trip memorable and worry-free.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Bus Hire for School Trips in Pune",
      "description": "Bus Hire for School Trips in Pune offers safe and reliable transportation solutions tailored specifically for school outings, picnics, and educational excursions. The service emphasizes child safety, timely pickups, and well-maintained vehicles to ensure a comfortable and stress-free travel experience for students, teachers, and accompanying staff."
    },
    {
      "name": "School Bus Rental Pune",
      "description": "School Bus Rental Pune provides a fleet of buses specially designed to meet the needs of schools and educational institutions. These buses come equipped with safety features, comfortable seating, and professional drivers trained to handle student passengers, making them ideal for daily commutes as well as special school events and trips."
    },
    {
      "name": "Educational Trip Bus Pune",
      "description": "Educational Trip Bus Pune caters to schools organizing learning excursions and field trips, offering reliable buses that ensure safe and comfortable travel to museums, science centers, historical sites, and other educational destinations. The service includes flexible scheduling and customized routes tailored to the trip’s itinerary."
    },
    {
      "name": "School Tour Bus Pune",
      "description": "School Tour Bus Pune specializes in providing buses for multi-day tours, school competitions, and inter-school events. With spacious seating, luggage space for student bags, and courteous drivers, this service supports long-distance and local tours, ensuring punctual and safe transport throughout the journey."
    },
    {
      "name": "School Picnic Bus Pune",
      "description": "School Picnic Bus Pune offers buses for day-long picnics and outings, focusing on convenience and comfort for students and staff. The service ensures on-time pickups and drop-offs, clean and well-maintained vehicles, and attentive drivers to make school picnics enjoyable and hassle-free."
    },
    {
      "name": "AC School Bus Pune",
      "description": "AC School Bus Pune provides fully air-conditioned buses ideal for Pune’s warm climate, ensuring students travel in a cool and comfortable environment. This service is popular for longer trips, summer outings, and any journey where passenger comfort is a priority."
    },
    {
      "name": "Non AC School Bus Pune",
      "description": "Non AC School Bus Pune offers economical bus rental options without air conditioning, suitable for shorter trips or budget-conscious schools. Despite lacking AC, these buses maintain high standards of cleanliness, safety, and reliability, providing practical transportation solutions for daily use and short excursions."
    },
    {
      "name": "Mini Bus for School Trip Pune",
      "description": "Mini Bus for School Trip Pune caters to smaller groups or classes requiring more personalized transportation. These compact buses offer flexibility, easy maneuverability, and safety features, making them perfect for smaller school trips, staff travel, or specialized outings."
    },
    {
      "name": "Large School Bus Pune",
      "description": "Large School Bus Pune offers high-capacity buses designed to accommodate bigger student groups comfortably. Equipped with spacious seating and safety measures, these buses are ideal for large school tours, inter-school events, and mass student transportation, ensuring everyone travels together safely and on time."
    },
    {
      "name": "School Bus Hire in Hinjewadi",
      "description": "School Bus Hire in Hinjewadi provides specialized school transportation services within the Hinjewadi area, catering to schools and colleges. This service is known for punctuality, well-maintained buses, and experienced drivers familiar with local routes, ensuring safe and efficient student travel."
    },
    {
      "name": "School Bus Hire in Hadapsar",
      "description": "School Bus Hire in Hadapsar offers dependable school bus rentals tailored to the needs of educational institutions in the Hadapsar region. With a focus on safety, cleanliness, and timely service, this option supports daily commutes and special school events in and around Hadapsar."
    },
    {
      "name": "School Bus Hire in Pimpri",
      "description": "School Bus Hire in Pimpri caters to schools and educational organizations in Pimpri Chinchwad, providing reliable buses for daily routes, school trips, and extracurricular events. The service ensures professional drivers and vehicles equipped to transport students securely and comfortably."
    },
    {
      "name": "Affordable School Bus Pune",
      "description": "Affordable School Bus Pune offers budget-friendly school bus rental options without compromising on safety or quality. This service is ideal for schools seeking cost-effective transportation solutions for daily commutes, outings, or special events, featuring transparent pricing and flexible packages."
    },
    {
      "name": "Safe School Bus Hire Pune",
      "description": "Safe School Bus Hire Pune prioritizes student safety with well-maintained vehicles, seat belts, and professional drivers trained in child passenger care. This service adheres to all safety regulations, providing peace of mind to parents and schools when arranging student transportation."
    },
    {
      "name": "School Excursion Bus Pune",
      "description": "School Excursion Bus Pune specializes in buses for educational excursions and adventure trips, supporting schools with vehicles that accommodate necessary luggage and equipment. The service includes experienced drivers familiar with popular excursion destinations and flexible scheduling to match school timetables."
    },
    {
      "name": "Bus Hire for Colleges Pune",
      "description": "Bus Hire for Colleges Pune provides transportation services for college students and staff, facilitating travel for academic trips, seminars, workshops, and sports events. The fleet includes buses of various sizes to accommodate different group requirements while ensuring safety and comfort."
    },
    {
      "name": "College Tour Bus Pune",
      "description": "College Tour Bus Pune offers tailored bus rental services for college tours, educational visits, and inter-college events. With spacious seating and ample luggage space, these buses provide a comfortable travel experience for students and faculty during short or extended trips."
    },
    {
      "name": "School Bus Booking Pune",
      "description": "School Bus Booking Pune features an easy and efficient booking system allowing schools and parents to reserve buses quickly for daily transportation or special events. With options for different bus types and capacities, this service streamlines the process, ensuring availability and timely service."
    }
  ],
  "tableData": [
    ["Bus Hire for School Trips in Pune", "School Bus Rental Pune"],
    ["Educational Trip Bus Pune", "School Tour Bus Pune"],
    ["School Picnic Bus Pune", "AC School Bus Pune"],
    ["Non AC School Bus Pune", "Mini Bus for School Trip Pune"],
    ["Large School Bus Pune", "School Bus Hire in Hinjewadi"],
    ["School Bus Hire in Hadapsar", "School Bus Hire in Pimpri"],
    ["Affordable School Bus Pune", "Safe School Bus Hire Pune"],
    ["School Excursion Bus Pune", "Bus Hire for Colleges Pune"],
    ["College Tour Bus Pune", "School Bus Booking Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire for School Trips in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides safe and reliable bus hire services in Pune, perfect for school trips and educational excursions."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Sizes",
    "WhyChoosedescription": "Choose from multiple seating capacities to comfortably accommodate students, teachers, and staff."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are regularly serviced and sanitized to ensure a hygienic and safe travel environment for young passengers."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Benefit from clear, budget-friendly pricing with no hidden fees, ideal for school budgets."
  },
  {
    "WhyChooseheading": "Flexible Rental Durations",
    "WhyChoosedescription": "Hire buses for half-day, full-day, or multiple-day trips tailored to your school’s itinerary."
  },
  {
    "WhyChooseheading": "Experienced and Responsible Drivers",
    "WhyChoosedescription": "Our professional drivers prioritize student safety, punctuality, and courteous service throughout the trip."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, changes, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your school trip bus easily online or by phone, with prompt and reliable service in Pune."
  }
]































  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus hire services for school trips in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides safe and comfortable bus hire services for school trips in Pune.',
  },
  {
    question: 'How can I book a bus for a school trip in Pune with Amruta Travels?',
    answer: 'Booking is easy via our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for school trip hires in Pune?',
    answer: 'We offer mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to accommodate different group sizes for school trips.',
  },
  {
    question: 'Are the drivers experienced and trained for school trip bus hires in Pune?',
    answer: 'Yes, our drivers are professional, courteous, and experienced in providing safe transportation for school trips.',
  },
  {
    question: 'Can buses be hired for day trips, educational tours, and excursions in Pune?',
    answer: 'Absolutely. Our buses are ideal for day trips, educational tours, excursions, and other school-related travel needs.',
  },
  {
    question: 'Is the bus hire service for school trips available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 bus hire services for school trips in Pune to fit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for school trip bus hires?',
    answer: 'All buses are sanitized thoroughly before each trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for school trip bus hires in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the school trip bus hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your school trip bus hire.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'Amruta Travels provided a safe and comfortable bus for our school trip in Pune. The driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Excellent service and punctual bus hire for our school excursion. Highly recommend Amruta Travels Pune.',
    rating: 5,
  },
];



































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for School Trips in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/17.jpg",
  "description": "Book Bus Hire for School Trips in Pune with Amruta Travels Pvt. Ltd. Safe, comfortable, and affordable AC & Non-AC buses for school picnics, educational tours, and college outings. Reliable school bus rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "15600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-hire-for-school-trips-in-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Bus Hire for School Trips in Pune | Safe & Comfortable School Bus Rental | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Bus Hire for School Trips in Pune with Amruta Travels Pvt. Ltd. Offering safe, comfortable, and affordable AC & Non-AC buses for school tours, picnics, and college outings. Trusted school bus rental in Pune."
  />
  <meta
    name="keywords"
    content="Bus Hire for School Trips in Pune, School Bus Rental Pune, Educational Trip Bus Pune, School Tour Bus Pune, School Picnic Bus Pune, AC School Bus Pune, Non AC School Bus Pune, Mini Bus for School Trip Pune, Large School Bus Pune, School Bus Hire in Hinjewadi, School Bus Hire in Hadapsar, School Bus Hire in Pimpri, Affordable School Bus Pune, Safe School Bus Hire Pune, School Excursion Bus Pune, Bus Hire for Colleges Pune, College Tour Bus Pune, School Bus Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforschooltripinpune;